import type { User } from '@chicare/shared';

/**
 * May this person open that screen?
 *
 * The server is the security boundary — every admin route carries the same
 * permission string in a `can:` middleware. This exists so the console does not
 * OFFER a door it knows is locked, and so typing the address gets a sentence
 * rather than a screen of skeletons that resolve into a 403.
 *
 * ── THE TWO ACCOUNTS WITH NO `permissions` LIST ─────────────────────────────
 *
 * A super admin is outside the permission system by definition, and the server
 * sends them the full list anyway. An admin account that predates roles has no
 * role, and the server keeps its old unlimited access rather than locking
 * everybody out on deploy (see User::may). Both arrive here with a list that
 * already says yes, so there is no special case — except a payload with no
 * `permissions` key at all, which is an older API, and is treated as staff
 * access rather than as a lockout.
 */
export function may(user: User | null | undefined, permission: string): boolean {
  if (!user) {
    return false;
  }

  if (!user.permissions) {
    return user.role === 'admin' || user.role === 'super_admin';
  }

  return user.permissions.includes(permission);
}
